<template>
    <div class="flex flex-col items-center justify-center h-screen">
        <div class="container mx-auto px-4 py-16">
            <div class="max-w-2xl mx-auto">
                <!-- Header -->
                <div class="text-center mb-8">
                    <div class="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full mb-4">
                        <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                        </svg>
                    </div>
                    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                        Connect your Stripe account
                    </h1>
                    <p class="text-lg text-gray-600 dark:text-gray-300">
                        Configure your account to receive payments securely
                    </p>
                </div>
                <div class="w-full hidden md:block">
                    <StripeButtonConnect />
                </div>
                <div class="mt-4 text-center">
                    <button class="underline text-sm text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100" @click="skipForNow">
                        Skip for now
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import StripeButtonConnect from './StripeButtonConnect.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const skipForNow = () => {
    router.push('/dataset-create')
}
</script>